import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';


import HeroSection from '../components/home/HeroSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import ForTeamsSection from '../components/home/ForTeamsSection';
import PricingSection from '../components/home/PricingSection';

const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

const UnderConstructionPage = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center px-4">
    <div className="max-w-2xl mx-auto text-center">
      <div className="mb-8">
        <div className="relative inline-block">
          <div className="absolute -inset-4 bg-yellow-400/20 rounded-full blur-2xl"></div>
          <img src="/logo.svg" alt="Postgame Buzz Logo" className="relative h-24 w-24 mx-auto" />
        </div>
      </div>
      <h1 className="text-5xl font-extrabold text-white mb-4">Postgame Buzz</h1>
      <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-6 mb-6">
        <h2 className="text-2xl font-bold text-yellow-400 mb-3">🚧 Under Construction</h2>
        <p className="text-gray-300 text-lg">We're currently working on some exciting updates and improvements.</p>
      </div>
      <p className="text-gray-400 text-base">
        Postgame Buzz is temporarily unavailable while we enhance our platform.<br />
        Check back soon for AI-generated sports podcasts!
      </p>
      <div className="mt-8 pt-8 border-t border-gray-700">
        <p className="text-gray-500 text-sm">
          Questions? Contact us at{' '}
          <a href="mailto:support@postgamebuzz.me" className="text-yellow-400 hover:text-yellow-300 transition-colors">
            support@postgamebuzz.me
          </a>
        </p>
      </div>
    </div>
  </div>
);

const HomePage = () => {
  useEffect(() => {
    if (window.location.hash === '#pricing') {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, []);

  if (MAINTENANCE_MODE) return <UnderConstructionPage />;

  const btnClass = "inline-flex items-center justify-center gap-2.5 bg-yellow-400 hover:bg-yellow-300 text-gray-900 font-black py-3 px-7 rounded-xl text-base transition-all duration-200 shadow-lg hover:shadow-xl hover:scale-105";

  // /create is public — guests build their request first and only sign in at the
  // final "generate" step, so every CTA routes straight into the builder.
  const GetStartedButton = () => (
    <Link to="/create" className={btnClass}>
      <img src="/logo.svg" alt="" className="h-5 w-5" aria-hidden="true" />
      <span>Try It With Your Game</span>
    </Link>
  );

  return (
    <div className="min-h-screen">
      <HeroSection />
      <HowItWorksSection />
      <ForTeamsSection />
      <PricingSection GetStartedButton={GetStartedButton} />

      {/* Bottom CTA */}
      <section className="bg-gradient-to-r from-gray-900 via-blue-950 to-gray-900 border-t-4 border-yellow-400">
        <div className="max-w-3xl mx-auto text-center py-20 px-4 sm:px-6 lg:px-8">
          <span className="inline-block text-xs font-bold text-yellow-400 uppercase tracking-widest mb-4">Don't Let the Moment Slip By</span>
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4 tracking-tight">
            That Game Deserves More Than a Screenshot
          </h2>
          <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto">
            Turn today's box score into a recap the whole family will want to hear. Upload a photo or PDF — ready in minutes.
          </p>
          <GetStartedButton />
        </div>
      </section>
    </div>
  );
};

export default HomePage;
